import { render, staticRenderFns } from "./WizardContentPatientIndicator.vue?vue&type=template&id=3ab1a5c2&"
import script from "./WizardContentPatientIndicator.vue?vue&type=script&lang=ts&"
export * from "./WizardContentPatientIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports